export const TEAM_LABEL = "TEAM_LABEL";

export const TEAM_MEMBER_1_NAME = "TEAM_MEMBER_1_NAME";
export const TEAM_MEMBER_1_ROLE = "TEAM_MEMBER_1_ROLE";
export const TEAM_MEMBER_1_DESCRIPTION = "TEAM_MEMBER_1_DESCRIPTION";

export const TEAM_MEMBER_2_NAME = "TEAM_MEMBER_2_NAME";
export const TEAM_MEMBER_2_ROLE = "TEAM_MEMBER_2_ROLE";
export const TEAM_MEMBER_2_DESCRIPTION = "TEAM_MEMBER_2_DESCRIPTION";


export const TEAM_MEMBER_3_NAME = "TEAM_MEMBER_3_NAME";
export const TEAM_MEMBER_3_ROLE = "TEAM_MEMBER_3_ROLE";
export const TEAM_MEMBER_3_DESCRIPTION = "TEAM_MEMBER_3_DESCRIPTION";

export const TEAM_MEMBER_4_NAME = "TEAM_MEMBER_4_NAME";
export const TEAM_MEMBER_4_ROLE = "TEAM_MEMBER_4_ROLE";
export const TEAM_MEMBER_4_DESCRIPTION = "TEAM_MEMBER_4_DESCRIPTION";

export const TEAM_MEMBER_5_NAME = "TEAM_MEMBER_5_NAME";
export const TEAM_MEMBER_5_ROLE = "TEAM_MEMBER_5_ROLE";
export const TEAM_MEMBER_5_DESCRIPTION = "TEAM_MEMBER_5_DESCRIPTION";

export const TEAM_MEMBER_6_NAME = "TEAM_MEMBER_6_NAME";
export const TEAM_MEMBER_6_ROLE = "TEAM_MEMBER_6_ROLE";
export const TEAM_MEMBER_6_DESCRIPTION = "TEAM_MEMBER_6_DESCRIPTION";